import TaskAllocationAmount from '../../../../../shared_components/Missions/TaskAllocationAmount'
import SharedReferralTask, {
  Props,
} from '../../../../../shared_components/Missions/Types/Referral'

const ReferralTask = (props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>) => {
  return <SharedReferralTask
    {...props}
    taskAmount={<TaskAllocationAmount taskId={props.taskId} />}
  />
}

export default ReferralTask
